import { render, staticRenderFns } from "./TrcsDues.vue?vue&type=template&id=3648a87e&"
import script from "./TrcsDues.vue?vue&type=script&lang=js&"
export * from "./TrcsDues.vue?vue&type=script&lang=js&"
import style0 from "./TrcsDues.vue?vue&type=style&index=0&id=3648a87e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VChip,VExpandTransition,VIcon,VSpacer,VTab,VTabItem,VTabs})
